(ns machtfit.multi-item-select
  (:require [clojure.set :refer [difference union]]
            [clojure.string :as str]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.utils :as utils]
            [re-frame.core :as rf]))

(rf/reg-sub ::filter-text
  (fn [db [_ id]]
    (-> db :ui id :filter-text)))

(defn- filtered-ids [filter-text items]
  (->> items
       (filter #(utils/matches-filter (:name %) filter-text))
       (sort-by :name)))

(defn- items-filter [{:keys [id]}]
  (widgets/filter-input {:filter-text @(rf/subscribe [::filter-text id])
                         :on-change #(rf/dispatch [:set-path [:ui id :filter-text] %])}))

(rf/reg-sub ::selected-count
  (fn [[_ selected-ids-sub]]
    [(rf/subscribe selected-ids-sub)])

  (fn [[selected-ids] _]
    (count selected-ids)))

(rf/reg-sub ::items-options-count
  (fn [[_ options-sub]]
    [(rf/subscribe options-sub)])

  (fn [[items-options] _]
    (count items-options)))

(rf/reg-sub ::every-filtered-selected?
  (fn [[_ id options-sub selected-ids-sub _pred]]
    [(rf/subscribe options-sub)
     (rf/subscribe selected-ids-sub)
     (rf/subscribe [::filter-text id])])

  (fn [[items-options selected-ids filter-text] [_ _id _options-sub _selected-ids-sub pred]]
    (when pred (every? pred
                       (->> items-options
                            (filter #(utils/matches-filter (:name %) filter-text))
                            (map #(contains? selected-ids (:id %))))))))

(defn- select-by-filter [{:keys [id options-sub selected-ids-sub on-selected-ids-changed]} unselect?]
  (let [items-options @(rf/subscribe options-sub)
        selected-ids @(rf/subscribe selected-ids-sub)
        filter-text @(rf/subscribe [::filter-text id])
        filtered-items (set (map :id (filtered-ids filter-text items-options)))
        select-fn (if unselect? difference union)]
    (on-selected-ids-changed (select-fn selected-ids filtered-items))))

(defn- item-option [{:keys [id selected-ids-sub on-selected-ids-changed]} item]
  (let [selected-ids @(rf/subscribe selected-ids-sub)
        item-id (:id item)
        global-id (str id "-" item-id)
        checked? (utils/in? selected-ids item-id)]
    [:li
     {:class (when checked? "active")}
     [:input.filled-in {:id global-id
                        :type "checkbox"
                        :checked checked?
                        :on-change #(on-selected-ids-changed (if (contains? selected-ids item-id) (disj selected-ids item-id) (conj selected-ids item-id)))}]
     [:label {:for global-id} (:name item)]]))

(defn- items [{:keys [id options-sub selected-ids-sub] :as config} only-selected? advanced-mode?]
  (let [selected-ids @(rf/subscribe selected-ids-sub)
        items-options @(rf/subscribe options-sub)
        items-to-show (if only-selected?
                        (filter #(utils/in? selected-ids (:id %)) items-options)
                        items-options)
        filtered-items (filtered-ids @(rf/subscribe [::filter-text id]) items-to-show)]
    [:ul.dropdown-content.select-dropdown.multiple-select-dropdown
     {:class (if advanced-mode? "advanced" "simple")
      :style {:width "100%"
              :position "relative"
              :display "block"
              :opacity "1"
              :height (when advanced-mode? "20rem")
              :margin-bottom "0.5rem"}}
     (doall (for [item filtered-items]
              ^{:key (:id item)}
              [item-option config item]))]))

(defn- match-stats [{:keys [id options-sub match-stats-strings]}]
  (let [items-options @(rf/subscribe options-sub)
        items-options-count @(rf/subscribe [::items-options-count options-sub])
        filter-text @(rf/subscribe [::filter-text id])
        filter-text-empty? (str/blank? filter-text)
        filtered-count (count (filtered-ids filter-text items-options))]
    [:div.match-stats
     (str filtered-count
          (when-not filter-text-empty? (str " von " items-options-count))
          " " (if (= items-options-count 1)
                (:singular match-stats-strings)
                (:plural match-stats-strings)))]))

(defn- selected-stats [{:keys [selected-ids-sub selected-stats-strings]}]
  (let [selected-count @(rf/subscribe [::selected-count selected-ids-sub])
        {:keys [zero one multiple]} selected-stats-strings]
    [:div.selected-stats
     {:style {:text-align "right"}}
     (case selected-count
       0 zero
       1 one
       (str selected-count " " multiple))
     " ausgewählt"]))

(defn- select-buttons [{:keys [id options-sub selected-ids-sub] :as config}]
  [:div.select-buttons
   [:a.btn-link
    (if @(rf/subscribe [::every-filtered-selected? id options-sub selected-ids-sub true?])
      {:class "disabled"}
      {:on-click #(select-by-filter config false)})
    "alle auswählen"]
   [:a.btn-link
    (if @(rf/subscribe [::every-filtered-selected? id options-sub selected-ids-sub false?])
      {:class "disabled"}
      {:on-click #(select-by-filter config true)})
    "keine auswählen"]])

(defn multi-item-select [{:keys [options-sub] :as config}]
  (let [items-options-count @(rf/subscribe [::items-options-count options-sub])
        show-select-all-buttons? (> items-options-count 5)
        advanced-mode? (> items-options-count 10)]
    (if advanced-mode?
      [:div.multi-item-select.advanced
       [items-filter config]
       [match-stats config]
       [:div.source
        [items config false true]]
       (when show-select-all-buttons? [select-buttons config])
       [selected-stats config]
       [:div.target
        [items config true true]]]

      [:div.multi-item-select.simple
       [:div.source
        [items config false false]
        (when show-select-all-buttons? [select-buttons config])]])))
